import { Dictionary } from 'src/app/shared/types/dictionary';

export interface Locales {
	/**
	 * Holds all sections.
	 */
	[section: string]: Dictionary<string>;
}

export interface LocaleState {
	/**
	 * Are we currently loading locales?
	 */
	loading: boolean;
	/**
	 * Are we loading angular's locale files?
	 */
	loadingFiles: boolean;
	/**
	 * The actual locale state.
	 */
	locales: Locales;
}

export const initialState: LocaleState = {
	loading: false,
	loadingFiles: false,
	locales: {},
};
